import { InvariantError } from "@apollo/client/utilities/globals";

// Apollo's clearStore() rejects every in-flight query with this invariant. Production builds swap
// the text for an error URL that carries the code, so both forms are recognised.
export const STORE_RESET_CODE = 32;
const STORE_RESET_TEXT = "Store reset while query was in flight";

const codeFromErrorUrl = (message: string): number | undefined => {
  const encoded = message.split("#")[1];
  if (!encoded) return undefined;
  try {
    const parsed: { message?: unknown } = JSON.parse(decodeURIComponent(encoded));
    return typeof parsed.message === "number" ? parsed.message : undefined;
  } catch {
    return undefined;
  }
};

export const isStoreResetError = (error: unknown): boolean =>
  error instanceof InvariantError &&
  (error.message.includes(STORE_RESET_TEXT) || codeFromErrorUrl(error.message) === STORE_RESET_CODE);
